module.exports = __webpack_public_path__ + "img/spin_wheel_bg_rt.1b87f06c.png";